import { Controller } from "@hotwired/stimulus"

// Insère un modèle de réponse dans le textarea du compose box.
// Cherche le data-chat-target="input" rendu par messages/_form.html.erb.
export default class extends Controller {
  fill(event) {
    const text = event.currentTarget.dataset.replyTemplatesValue
    if (!text) return

    const form = this.element.parentElement?.querySelector("#message_form")
    const input = form?.querySelector("[data-chat-target='input']")
    if (!input) return

    input.value = text
    input.focus()
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
